import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";

function Loader() {
  return (
    <div className="flex h-screen items-center justify-center bg-[#E9E9EB]">
      <div className="h-10 w-10 animate-spin rounded-full border-4 border-[#C2C9D1] border-t-[#034AA2]" />
    </div>
  );
}

// The route guard. Kept in its own module (not inlined in App.js) so its
// redirect behavior can be unit-tested without loading every page — a static
// "the route carries studentOnly" check could pass against a prop the
// component ignored, so the test renders this for real. (ZEN-142)
export function Protected({ children, ownerOnly, studentOnly }) {
  const { user } = useAuth();
  if (user === null) return <Loader />;
  if (!user) return <Navigate to="/auth" replace />;
  if (ownerOnly && user.role !== "owner") return <Navigate to="/" replace />;
  // The beneficiary-only pages. /my-receipts was routed as merely "logged
  // in" while every sibling was role-gated, so an owner who typed the
  // address reached the beneficiary's upload page (ZEN-142). This gate is
  // courtesy — the server refuses the upload itself — but the courtesy
  // matters: the page's data call 403s for an owner, so what they saw was a
  // broken-looking page with a working camera button.
  if (studentOnly && user.role !== "student") return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

export default Protected;
